exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flexRow[data-v-417eb9f0]{align-items:baseline}.faq[data-v-417eb9f0]{max-width:800px;margin:auto}.label[data-v-417eb9f0]{width:100px}ul[data-v-417eb9f0]{display:inline-block;margin-left:2rem;text-align:left;list-style-type:square;max-width:650px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-417eb9f0&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/HelpView.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-417eb9f0&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/views/HelpView.vue
// module chunks = 0